import { render, staticRenderFns } from "./ItemBarNotification.vue?vue&type=template&id=4c468296"
import script from "./ItemBarNotification.vue?vue&type=script&lang=js"
export * from "./ItemBarNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports